import { render, staticRenderFns } from "./AutomaticFaceRecognition.vue?vue&type=template&id=12eb556a&scoped=true&"
import script from "./AutomaticFaceRecognition.vue?vue&type=script&lang=js&"
export * from "./AutomaticFaceRecognition.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "12eb556a",
  null
  
)

export default component.exports